import React from "react"
import { PageContainerWrapper } from "../App"
import { Box, IconButton, Link, Typography } from "@mui/material"
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded"
import city_map from "../assets/img/city_map.png"

const ContactsPage = () => {
	return (
		<PageContainerWrapper>
			<Typography variant="h3">КОНТАКТЫ</Typography>
			<Typography variant="h6" gutterBottom>
				директор:
			</Typography>
			<Typography variant="subtitle1" gutterBottom>
				ОНИЩУК АНАТОЛИЙ НИКОЛАЕВИЧ
			</Typography>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					marginBottom: "20px",
				}}
			>
				<Link type="phone" href="tel:+375296113213" underline="hover" mb={0.5}>
					тел. моб. 8029-6-113-213
				</Link>
				<Link type="phone" href="tel:+375296113213" underline="none" mb={0.5}>
					<IconButton color="success">
						<PhoneForwardedIcon />
					</IconButton>
				</Link>
			</Box>
			<Typography variant="h6">адрес:</Typography>
			<Typography variant="subtitle1" gutterBottom>
				ул. Стариновская, д. 7, офис 5
			</Typography>
			<Typography variant="subtitle1" gutterBottom>
				г. Минск
			</Typography>
			<Typography variant="subtitle1" paragraph>
				220056
			</Typography>

			<Typography variant="h6">телефоны:</Typography>

			<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
				<Link type="phone" href="tel:80173480978" underline="hover" mb={0.5}>
					Тел. (017) 348-09-78
				</Link>
				<Link type="phone" href="tel:80173480978" underline="hover" mb={0.5}>
					<IconButton color="warning">
						<PhoneForwardedIcon />
					</IconButton>
				</Link>
			</Box>

			<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
				<Link type="phone" href="tel:+375296113213" underline="hover" mb={0.5}>
					тел. моб. 8029-6-113-213
				</Link>
				<Link type="phone" href="tel:+375296113213" underline="none" mb={0.5}>
					<IconButton color="success">
						<PhoneForwardedIcon />
					</IconButton>
				</Link>
			</Box>

			<Typography paragraph>email: geozemplan@tut.by</Typography>

			<Box sx={{ width: "100%", overflow: "hidden" }}>
				<img src={city_map} alt="city_map svg" style={{ maxWidth: "100%" }} />
			</Box>
		</PageContainerWrapper>
	)
}

export default ContactsPage
